import { Button } from '../../../components/base/Button';

const HeroSection = () => {
  return (
    <section 
      id="home" 
      className="min-h-screen flex items-center justify-center relative bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/93c02235d69b8e534a74a96889a675d9.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white relative z-10">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-5xl md:text-6xl font-bold mb-6 leading-tight" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
            あなたの<span className="text-blue-400">財務目標</span>を
            <br />
            現実にする
          </h2>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 leading-relaxed">
            TOUAREG GLOBALは、個人投資家から機関投資家まで、
            <br />
            幅広いクライアントに最高水準の投資・資産管理サービスを提供します
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              variant="primary" 
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg font-semibold whitespace-nowrap"
              href="#contact"
            >
              <span className="flex items-center gap-2">
                無料相談を予約
                <i className="ri-arrow-right-line"></i>
              </span>
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 text-lg font-semibold whitespace-nowrap"
              href="#services"
            >
              <span className="flex items-center gap-2">
                サービス詳細
                <i className="ri-play-circle-line"></i>
              </span>
            </Button>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#about" className="text-white hover:text-blue-400 transition-colors">
          <i className="ri-arrow-down-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
